import { BaseService } from '../../infra/base.service'
import type { Setting, SettingConfig } from './setting'
import type { SettingsRepository } from './settings.repository'

export class SettingsService extends BaseService<Setting> {
    constructor(private rep: SettingsRepository) {
        super(rep)
    }

    async updateFlags(entity: Partial<Setting>) {
        return await this.rep.updateFlags(entity)
    }

    async getFlags() {
        return await this.rep.getFlags()
    }

    async updateConfigs(entity: Partial<SettingConfig>) {
        const result = await this.rep.updateConfigs(entity)
        window.configs = result.configs
        return result
    }

    async getConfigs() {
        return await this.rep.getConfigs()
    }
}
